import type { DealState } from '@openx/types/deal.ts';
import { AudienceStatus } from '@openx/types/targeting/audience.ts';

/**
 * Checks if a deal can be activated based on its attached audience status.
 * Returns an object with `allowed` boolean and optional `message` string.
 */
export const canActivateDealWithAudience = (deal: DealState): { allowed: boolean; message?: string } => {
  if (!deal.audience_status) {
    return { allowed: true };
  }

  const audienceStatus = deal.audience_status;

  if (audienceStatus === AudienceStatus.EXPORTING) {
    return {
      allowed: false,
      message: 'Deal Status cannot be changed while the attached Audience is exporting.',
    };
  }

  if (audienceStatus === AudienceStatus.EXPIRED) {
    return {
      allowed: false,
      message: 'Deal Status cannot be changed because the attached Audience has expired.',
    };
  }

  return { allowed: true };
};
